import { configure } from 'core';
import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import { NoRobotsModal } from 'apps/modals/noRobotsException';
import { PaymentOverdueModal } from 'apps/payment/views/overdue';

const conf = {
  onAuthenticationError: () => {
    // If a tab receives an authentication error it should only be because the user is actually signed out, so we should 'sign-out the client'.
    // Could cause a problem if the server returns an authentication error when it should not - signing out the user unintentionally.
    clientStore.SignOutUser();
    clientStore.routerStore.navigate('home.signIn', {
      next: clientStore.next(),
    });
  },
  onUserMismatchError: () => {
    clientStore.WhoAmI(true);
  },
  onNotConfirmedError: () => {
    clientStore.routerStore.navigate('onboarding.confirmProfile');
  },
  onPaymentOverdueError: () => {
    modalStore.SetModalComponent(PaymentOverdueModal);
  },
  onNoBot: error => {
    // would be useful to get the action here, to respond accordingly
    modalStore.SetModalComponent(NoRobotsModal, {
      action: error.extensions.code,
    });
  },
  // onAuthorisationError:
  // onRedirectError:
  // onNotFoundError:
  // onValidation
};

export function configure_bloqi() {
  configure(conf);
}
